<template>
  <button
    type="button"
    class="focus:outline-none text-lg rounded-lg font-bold w-12 h-20 border-2  transform duration-150 my-2 mx-2"
    :class="value ? 'border-0 text-white bg-blue-500 bg-opacity-90 -translate-y-3' : 'border-blue-500 text-blue-400 bg-opacity-50 hover:transform hover:-translate-y-1 hover:bg-blue-50'"
  >

    {{ number }}
  </button>
</template>

<script>
export default {
  props: {
    number: {
      type: String,
      default: null,
    },
    value: {
      type: Boolean,
      default: false,
    },
  },
  components: {},
  data: function () {
    return {
      isClicked: false,
    };
  },
  computed: {},
  methods: {},
  created() {},
  mounted() {},
};
</script>

<style>

</style>